import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_COUPON_DISCOUNT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemCouponDiscountMaybe = props => {
  const { lineItems, intl } = props;

  const couponDiscountLineItem = lineItems.find(
    item => item.code === LINE_ITEM_COUPON_DISCOUNT && !item.reversal
  );

  return couponDiscountLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.couponDiscount" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, couponDiscountLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemCouponDiscountMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemCouponDiscountMaybe;
